// extracted by mini-css-extract-plugin
export var boxItems = "_9e-1";
export var boxItemsLg = "_9e-2";
export var button = "_9e-7";
export var buttonHoverless = "_9e-9";
export var buttonLg = "_9e-8";
export var filterGroupBox = "_9e-0";
export var icon = "_9e-3";
export var iconSecondary = "_9e-6";
export var iconWrapper = "_9e-4";
export var iconWrapperLg = "_9e-5";
export var truncatedLabel = "_9e-a";